import React from "react";
import { Grid } from "semantic-ui-react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

import splitArrayByPattern from "@common/components/helpers/split";
import { renderRow } from "@common/components/helpers/renderGridRow";
import { urlMappings } from "@common/components/helpers/urlMappings";
import LoginAction from "@common/redux/actions/LoginAction";
import { useWindowWidth } from "@common/components/helpers/useWindowWidth";
import { redirectOptions } from "@common/components/helpers/options/navigationOptions";

const RedirectDashboard = () => {
  const history = useHistory();
  const width = useWindowWidth();
  const { menu } = useSelector((store) => LoginAction.getStatePath(store));
  const splitMenu = splitArrayByPattern(
    menu
      .find((x) => x.code === "COMPLIANCE")
      .menu.filter((x) => redirectOptions.includes(x.code)),
  );

  return (
    <>
      <p>
        <b>Please select one of the following:</b>
      </p>
      <div className="flex-center">
        <Grid className="m-1 mw-50em mh-50" padded={width < 700} columns={2}>
          {splitMenu.map((rowItems, rowIndex) =>
            renderRow("tiny", rowItems, rowItems.length, rowIndex, (item) =>
              history.push(urlMappings.get(item.code)),
            ),
          )}
        </Grid>
      </div>
    </>
  );
};

export default RedirectDashboard;
